import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CategoryData {
  category?: string;
  description?: string;
  imageUrl?: string;
}

@Component({
  selector: 'app-add-category-dialog',
  standalone: false,
  templateUrl: './add-category-dialog.component.html',
  styleUrl: './add-category-dialog.component.scss',
})
export class AddCategoryDialogComponent {
  categoryName = '';
  categoryDescription = '';
  selectedFile: File | null = null;
  previewImage: string | null = null;
  isEditMode = false;

  constructor(
    private dialogRef: MatDialogRef<AddCategoryDialogComponent, CategoryData>,
    @Inject(MAT_DIALOG_DATA) public data: CategoryData
  ) {
    if (data && data.category) {
      this.isEditMode = true;
      this.categoryName = data.category!;
      this.categoryDescription = data.description || '';
      this.previewImage = data.imageUrl || null;
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    this.selectedFile = input.files[0];
    const reader = new FileReader();
    reader.onload = () => (this.previewImage = reader.result as string);
    reader.readAsDataURL(this.selectedFile);
  }

  submitCategory() {
    if (!this.categoryName.trim()) {
      // mark form submitted to trigger mat-error
      return;
    }

    this.dialogRef.close({
      category: this.categoryName.trim(),
      description: this.categoryDescription.trim(),
      imageUrl: this.previewImage || undefined,
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
